<template>
  <div class="loading" :class="{active: isLoading}">
    <div class="indicator">
      <i class="fas fa-spinner fa-pulse"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  mixins: [],
  props: ['isLoading'],
}
</script>

<style lang="scss">
.loading {
  display: flex;
  justify-content: center;
  margin-top: 200px;
  margin-bottom: 200px;

  i {
    font-size: 100px;
    color: #c00005;
  }
}
</style>
